import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({ name: 'individualMultiplierView', standalone: true })
export class IndividualMultiplierPipe implements PipeTransform {
  private readonly decimalPipe = inject(DecimalPipe);

  transform(originalValue: number, digits = 1): string {
    return this.decimalPipe.transform(originalValue, `1.${digits}-${digits}`);
  }
}
